import {
  FlexAnchor,
  Heading,
  Icon,
  PromotionalBannerActivated,
  Typo,
  xxsBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'

interface PromotionBannerActivatedProps {
  onOfferTermsClick: () => void
}

const tKey = TKey('components.promotion-banner-activated')

export const PromotionBannerActivated: FunctionComponent<
  PromotionBannerActivatedProps
> = ({ onOfferTermsClick }) => {
  const { t } = useWriskTranslation()

  return (
    <PromotionalBannerActivated>
      <Heading variant='h3' typoSize='lg'>
        {t(tKey('heading'))}
      </Heading>
      <FlexAnchor mt={[6, 6, 0]} color='white' onClick={onOfferTermsClick}>
        <Icon mr={xxsBumps} icon='info' size='tiny' />
        <Typo typoSize='sm' lineHeight={0}>
          {t(tKey('offerTerms'))}
        </Typo>
      </FlexAnchor>
    </PromotionalBannerActivated>
  )
}
